<!-- eslint-disable vue/no-mutating-props -->
<template>
    <v-row>
        <v-col cols="3">
            <v-select
                v-model="complaint.errorCodeGroupId"
                :items="errorCodeGroups"
                label="Grupa błędu"
                item-value="id"
                item-text="name"
                no-data-text="Brak grup błędu"
                clearable
                :disabled="isReadOnly"
                :error="isFieldInvalid('errorCodeGroupId')"
                :error-messages="validationMessages('errorCodeGroupId')"
                @change="handleErrorCodeGroupChange"
                @blur="triggerBlur('errorCodeGroupId')"
            />
        </v-col>

        <v-col cols="3">
            <v-select
                v-model="complaint.errorCodeId"
                :items="selectedErrorCodeGroup"
                label="Kod błędu"
                item-value="id"
                item-text="name"
                no-data-text="Brak kodów błędu"
                clearable
                :disabled="isReadOnly || !canPickErrorCode"
                :error="isFieldInvalid('errorCodeId')"
                :error-messages="validationMessages('errorCodeId')"
                @blur="triggerBlur('errorCodeId')"
            />
        </v-col>
    </v-row>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
export default {
    name: 'DetailsTabErrorsSection',

    props: {
        complaint: {
            type: Object,
            required: true,
        },
        validation: {
            type: Object,
            default: () => ({}),
        },
        isReadOnly: {
            type: Boolean,
        }
    },

    computed: {
        validationState() {
            const fields = ['errorCodeGroupId', 'errorCodeId']
            const provided = this.validation || {}

            return fields.reduce((acc, field) => {
                const entry = provided[field] || {}

                acc[field] = {
                    error: Boolean(entry.error),
                    messages: Array.isArray(entry.messages) ? entry.messages : [],
                }

                return acc
            }, {})
        },

        errorCodeGroups() {
            return this.$store.state.complaints.internalComplaints.errorCodeGroups
        },

        selectedErrorCodeGroup() {
            const groupId = this.complaint?.errorCodeGroupId

            if (!groupId) return []

            const group = this.errorCodeGroups?.find(item => item.id === groupId)

            return group?.errorCodes || []
        },

        canPickErrorCode() {
            return Boolean(this.complaint?.errorCodeGroupId)
        },
    },

    methods: {
        validationNode(field) {
            return this.validationState[field] || null
        },

        isFieldInvalid(field) {
            const node = this.validationNode(field)

            return Boolean(node && node.error)
        },

        validationMessages(field) {
            const node = this.validationNode(field)

            if (!node || !Array.isArray(node.messages)) return []

            return node.messages
        },

        triggerBlur(field) {
            this.$emit('field-blur', field)
        },

        handleErrorCodeGroupChange() {
            this.triggerBlur('errorCodeGroupId')
            this.complaint.errorCodeId = null
        },
    },
}
</script>
